import { endpoints, host } from '@config/endpoints';
import request from './request';

export const forgotPasswordRequest = async (email: string) => {
    const { path, method } = endpoints.users.forgotPassword;

  let err = null;
  let res: any = null;

  try {
    ({ data: res } = await request(
      `${host}${path}`,
      method,
      { email },
      {},
    ));
  } catch (error) {
    // @ts-ignore
    err = error.message;
  }

  return [err, res];
};
